import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 198c-19.4 0-38.3-5.7-54.4-16.5s-28.7-26.1-36.1-44C2 119.6.1 99.9 3.9 80.9c3.8-19 13.1-36.5 26.8-50.2s31.2-23 50.2-26.8c19-3.8 38.7-1.8 56.6 5.6 17.9 7.4 33.2 20 44 36.1 10.8 16.1 16.5 35 16.5 54.4 0 26-10.3 50.9-28.7 69.3A97.937 97.937 0 0 1 100 198zM64.1 55.2v96.2h15.8v-36.9h23.9c23.4 0 35.2-10 35.2-29.8s-11.9-29.3-35-29.3l-39.9-.2zm15.7 13.5h22.9c6.9 0 12 1.2 15.2 3.8 3.2 2.5 4.9 6.5 4.9 12.2 0 5.8-1.6 10-4.9 12.5-3.3 2.5-8.2 3.8-15.2 3.8H79.8V68.7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}